import * as Types from './Alert.d';
import Alert, { Alert as NotPureAlert } from './Alert';

export { NotPureAlert as Alert };
export type AlertProps = Types.AlertProps;
export type AlertWithRefProps = Types.AlertWithRefProps;
export default Alert;
